import { render } from "./ListClients.vue?vue&type=template&id=25e9ec3d"
import script from "./ListClients.vue?vue&type=script&lang=js"
export * from "./ListClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__